import { useParams } from "react-router-dom";
import { Button, Typography, Divider, TextField, Box, FormControl } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { axiosLogin } from "../../api/user";
import { reducerTypes } from "../../store/Users/types";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../store/reduxHooks";
import { PageContainer } from "../../components/Page.styled";
import { customAlert } from "../../components/Alert/AlertFunction";

function UserInput() {
  const dispatch = useDispatch();
  const { user } = useAppSelector((store) => store.user);
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [errorLogin, setErrorLogin] = useState("");
  const [emailDirty, setEmailDirty] = useState(false);
  const [passwordDirty, setPasswordDirty] = useState(false);
  const [formValid, setFormValid] = useState(false);
  const navigate = useNavigate();
  const { logout } = useParams();
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");

  const blurHandler = (e) => {
    switch (e.currentTarget.name) {
      case "login":
        setEmailDirty(true);
        break;
      case "password":
        setPasswordDirty(true);
        break;
      default:
    }
  };

  function cheakLengthLogin(e) {
    if (e.currentTarget.value.length < 5) {
      setErrorLogin("Мінімум 5 символів");
    } else {
      setErrorLogin("");
    }
  }

  function loginUser(e) {
    setLogin(e.currentTarget.value);
    // if(!validator.isEmail(e.currentTarget.value)) {
    //   setEmailError('Некоректный логин')
    // } else {
    setEmailError("");
    //}
  }

  function passwordUser(e) {
    setPassword(e.currentTarget.value);
    if (e.target.value.length < 4) {
      setPasswordError("Пароль вказаний невірно");
      if (!e.target.value) {
        setPasswordError("Пароль не вказано");
      }
    } else {
      setPasswordError("");
    }
  }

  useEffect(() => {
    if (emailError || passwordError || errorLogin) {
      setFormValid(false);
    } else {
      setFormValid(true);
    }
  }, [emailError, passwordError, errorLogin]);

  function offReserch(e) {
    e.preventDefault();
  }

  async function getUsers(e) {
    const result = await axiosLogin(login, password);
    if (!result?.message) {
      offReserch(e);
      dispatch({
        type: reducerTypes.GET_USER,
        payload: await axiosLogin(login, password),
      });
      console.log(2);
      navigate("/homepage");
    } else {
      customAlert({ message: result?.message });
    }
  }

  useEffect(() => {
    if (!user?.email) {
      // navigate("/login/true");
    } else {
      console.log(1);
      if (!logout) navigate("/homepage");
    }
  }, [navigate, user]);

  return (
    <PageContainer>
      <div style={{ padding: "1rem 10rem" }}>
        <Typography variant="h3" style={{ paddingBottom: "1rem" }}>
          Авторизація
        </Typography>
        <Divider />
        <FormControl style={{ maxWidth: "30vw", display: "flex", flexDirection: "column", gap: "2rem" }}>
          <Box style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
            <Typography>Електронна пошта користувача:</Typography>
            <TextField
              onBlur={(e) => blurHandler(e)}
              name="login"
              value={login}
              onChange={(e) => {
                loginUser(e);
                cheakLengthLogin(e);
              }}
              type="email"
              placeholder=""
            />
            {emailDirty && emailError && <div style={{ color: "red" }}>Електронна пошта не вказана</div>}
            {errorLogin ? <div style={{ color: "red" }}>Мінімум 5 символів</div> : ""}
          </Box>
          <Box style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
            <Typography>Пароль:</Typography>
            <TextField onBlur={(e) => blurHandler(e)} name="password" value={password} onChange={passwordUser} type="password" placeholder="" />
            {passwordDirty && passwordError && <div style={{ color: "red" }}>{passwordError}</div>}
          </Box>
          <Button variant="outlined" disabled={!formValid} onClick={(e) => getUsers(e)}>
            Увійти
          </Button>
        </FormControl>
      </div>
    </PageContainer>
  );
}

export default UserInput;
